import { render, staticRenderFns } from "./GalleryDashboardPortal.vue?vue&type=template&id=1986cc10"
import script from "./GalleryDashboardPortal.vue?vue&type=script&lang=ts"
export * from "./GalleryDashboardPortal.vue?vue&type=script&lang=ts"
import style0 from "./GalleryDashboardPortal.vue?vue&type=style&index=0&id=1986cc10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports